<template>
  <v-container fluid fill-height style="min-height: calc(100vh - 80px);">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="4" class="align-self-center">
        <v-card outlined rounded="lg">
          <v-card-text>
            <v-row class="black--text">
              <v-col cols="12">
                <h2 class="text-md-h5">
                  Forgot Password
                </h2>
                <p>
                  Your Email must be the same as the one you used to register.
                </p>
              </v-col>
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <v-form
                  @submit.prevent="submitReset"
                  ref="formreset"
                  v-model="formin.valid"
                  lazy-validation>
                  <v-text-field
                    v-model="reset.email"
                    :rules="rules.email"
                    label="Email"
                    name="email"
                    required>
                  </v-text-field>
                  <v-btn
                    type="submit"
                    large
                    block
                    :loading="loading.reset"
                    :disabled="loading.reset || !formin.valid"
                    :color="maincolor"
                    class="white--text mt-5">
                    Send Reset Password
                  </v-btn>
                  <div class="mt-3">
                    <v-row>
                      <v-col cols="12" md="12">
                        <div>
                          <router-link :to="{ name: 'Login' }">
                            Back to Log In
                          </router-link>
                        </div>
                        <div>
                          Don’t have an account?
                          <router-link :to="{ name: 'Register' }">
                            Create a free account
                          </router-link>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Forgetpass',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdatareg: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      reset: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    reset: {
      email: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {},
  created: () => ({
  }),
  mounted() {
    console.log('run');
  },
  methods: {
    getMyIp() {
      this.axios
        .get('https://api.ipify.org/?format=json')
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    submitReset() {
      this.alertdata.show = false;
      if (this.$refs.formreset.validate()) {
        this.loading.reset = true;
        this.axios
          .post(
            this.api + '/api/auth/resetpass',
            qs.stringify(
              this.reset,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // console.log(resdata);
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Link permintaan reset password telah dikirim ke email "' + this.reset.email + '", terimakasih';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.reset = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.reset = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
